import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';

export const clientRoutes: RouteConfig[] = [
  {
    path: '/client/dashboard',
    element: <Components.ClientDashboardPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/client/properties',
    element: <Components.ClientPropertiesPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/client/favorites',
    element: <Components.ClientFavoritesPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/client/appointments',
    element: <Components.ClientAppointmentsPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/client/appointments/nueva',
    element: <Components.ClientNewAppointmentPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/client/profile',
    element: <Components.ClientProfilePage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // Sprint 10 — Modelo C Híbrido: el buyer global controla qué agencias tienen
    // sus datos (ver/consent marketing/bloquear).
    path: '/client/mis-agencias',
    element: <Components.ClientMisAgenciasPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    // #790 #10 — búsquedas guardadas (alertas de propiedad por email).
    path: '/client/busquedas-guardadas',
    element: <Components.ClientSavedSearchesPage />,
    roles: ['BUYER_CLIENT'],
    requiresAuth: true,
    requiresLayout: true,
  },
];
